import { createContext, FC, ReactNode, useEffect, useState } from "react";

// Create Context
type ContextType = {
  screenSize: any;
  sidebarNav: boolean;
  setSidebarNav: (value: boolean) => void;
  subNavList: any[];
  setSubNavList: (value: []) => void;
  sidebarSubNav: boolean;
  setSidebarSubNav: (value: boolean) => void;
  formModal: boolean;
  setFormModal: (value: boolean) => void;
  paymentFormModal: boolean;
  setPaymentFormModal: (value: boolean) => void;
  composeFormModal: boolean;
  setComposeFormModal: (value: boolean) => void;
  formSubmitLoader: boolean;
  setFormSubmitLoader: (value: boolean) => void;
  paymentMethodModal: boolean;
  setPaymentMethodModal: (value: boolean) => void;
};
const DataContext = createContext<ContextType | null>(null);

// Create Context Provider and
interface Props {
  children: ReactNode;
}
const CommonContextProvider: FC<Props> = ({ children }) => {
  const [screenSize, setScreenSize] = useState<any>();
  const [subNavList, setSubNavList] = useState<any[]>([]);
  const [sidebarNav, setSidebarNav] = useState<boolean>(true);
  const [formModal, setFormModal] = useState<boolean>(false);
  const [sidebarSubNav, setSidebarSubNav] = useState<boolean>(false);
  const [composeFormModal, setComposeFormModal] = useState<boolean>(false);
  const [formSubmitLoader, setFormSubmitLoader] = useState<boolean>(false);
  const [paymentFormModal, setPaymentFormModal] = useState<boolean>(false);
  const [paymentMethodModal, setPaymentMethodModal] = useState<boolean>(false);

  useEffect(() => {
    window.onresize = displayWindowSize;
    window.onload = displayWindowSize;
    function displayWindowSize() {
      let myWidth = window.innerWidth;
      setScreenSize(myWidth);
    }
  }, []);

  return (
    <DataContext.Provider
      value={{
        screenSize,
        sidebarNav,
        setSidebarNav,
        subNavList,
        setSubNavList,
        sidebarSubNav,
        setSidebarSubNav,
        formModal,
        setFormModal,
        paymentFormModal,
        setPaymentFormModal,
        formSubmitLoader,
        composeFormModal,
        setComposeFormModal,
        setFormSubmitLoader,
        paymentMethodModal,
        setPaymentMethodModal,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export { DataContext, CommonContextProvider };
